export const MEDIA_CODE = 4;
export const HTML_CODE = 3;
export const TRANSCRIPTION_CODE = 10;